import { createSlice } from "@reduxjs/toolkit";

import { checkLiskProof } from "./actions";
import { getProof } from "../solana-proof/actions";

import { LiskProofState } from "./types";
import { LOCAL_STORAGE_KEYS } from "configs";

export const applyLiskToken = (key: string, token: LiskProofState["liskProofToken"]) => {
  if (token) {
    localStorage.setItem(key, token);
  } else {
    localStorage.removeItem(key);
  }

  return token;
};

const initialState: LiskProofState = {
  pending: false,
  error: null,
  liskProofToken: null,
};

const liskSlice = createSlice({
  name: "liskProof",
  initialState: {
    ...initialState,
    liskProofToken: localStorage.getItem(LOCAL_STORAGE_KEYS.liskToken),
  },
  reducers: {
    resetLiskProofState: () => {
      applyLiskToken(LOCAL_STORAGE_KEYS.liskToken, null);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.liskWallet);
      return initialState;
    },
  },
  extraReducers: builder => {
    builder
      // get proof payload
      .addCase(getProof.pending, state => {
        state.pending = true;
      })
      .addCase(getProof.fulfilled, (state, action) => {
        state.liskPayload = action.payload;
        state.error = null;
        state.pending = false;
      })
      .addCase(getProof.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload;
          state.pending = false;
        }
      })
      // check lisk proof
      .addCase(checkLiskProof.pending, state => {
        state.pending = true;
      })
      .addCase(checkLiskProof.fulfilled, (state, action) => {
        const { token } = action.payload;
        state.error = null;
        state.liskProofToken = applyLiskToken(LOCAL_STORAGE_KEYS.liskToken, token);
        state.pending = false;
      })
      .addCase(checkLiskProof.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload;
          state.liskProofToken = applyLiskToken(LOCAL_STORAGE_KEYS.liskToken, null);
          state.pending = false;
        }
      });
  },
});

export const { resetLiskProofState } = liskSlice.actions;

export default liskSlice;
